"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildUniqueEntityKeys = void 0;
var build_unique_key_1 = require("./build-unique-key");
var buildUniqueEntityKeys = function (entity) {
    if (!entity) {
        throw new Error('entity must be defined');
    }
    var type = entity.type, id = entity.id;
    if (!type) {
        throw new Error('type must be defined');
    }
    if (!id) {
        throw new Error('id must be defined');
    }
    return [
        (0, build_unique_key_1.buildUniqueKey)('queries.getCoconut', { type: type, id: id }),
        (0, build_unique_key_1.buildUniqueKey)('queries.listCoconutsByOwner', { type: type }),
        (0, build_unique_key_1.buildUniqueKey)('queries.listCoconutsByOwner', { type: type, id: id }),
    ];
};
exports.buildUniqueEntityKeys = buildUniqueEntityKeys;
//# sourceMappingURL=build-unique-entity-keys.js.map